import { Link } from "react-router-dom";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { Calendar, MapPin, Users } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { EventStatusBadge } from "@/components/Events/EventStatusBadge";
import type { EventWithRelations } from "@/hooks/useEvents";

interface EventCardProps {
  event: EventWithRelations;
  isDragging?: boolean;
}

export function EventCard({ event, isDragging }: EventCardProps) {
  return (
    <Link to={`/events/${event.id}`}>
      <Card
        className={`cursor-pointer transition-shadow hover:shadow-md ${
          isDragging ? "rotate-3 shadow-lg" : ""
        }`}
      >
        <CardHeader className="pb-2">
          <div className="flex items-start justify-between gap-2">
            <CardTitle className="line-clamp-1 text-sm font-medium">
              {event.name}
            </CardTitle>
            <EventStatusBadge status={event.status} />
          </div>
        </CardHeader>
        <CardContent className="space-y-2 text-xs text-muted-foreground">
          <div className="flex items-center gap-2">
            <Calendar className="h-3 w-3" />
            <span>
              {format(new Date(event.event_date), "d MMM yyyy", { locale: fr })}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <MapPin className="h-3 w-3" />
            <span className="line-clamp-1">{event.location}</span>
          </div>
          {event.organizer && (
            <div className="flex items-center gap-2">
              <Users className="h-3 w-3" />
              <span className="line-clamp-1">{event.organizer.name}</span>
            </div>
          )}
        </CardContent>
      </Card>
    </Link>
  );
}
